import _typeof from "@babel/runtime/helpers/esm/typeof";
import * as node from '../node/buffer-utils.node';
export function isBuffer(x) {
  return x && _typeof(x) === 'object' && x.isBuffer;
}
export function toBuffer(data) {
  return node.toBuffer ? node.toBuffer(data) : data;
}
export function bufferToArrayBuffer(data) {
  if (node.toArrayBuffer) {
    return node.toArrayBuffer(data);
  }

  return data;
}
//# sourceMappingURL=buffer-utils.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/loader-utils/dist/esm/lib/binary-utils/buffer-utils.js